document.addEventListener('DOMContentLoaded', function () {
  const policyHeaders = document.querySelectorAll(
    '.product-policy__header'
  );
  policyHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      const policy = header.closest('.product-policy');
      if (!policy) {
        return;
      }
      const isOpen = policy.classList.contains('is-open');
      policy.classList.toggle('is-open');
      header.setAttribute(
        'aria-expanded',
        isOpen ? 'false' : 'true'
      );
    });
  });
});

/////////// for product share icon 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-copy-link').forEach(function (button) {
    button.addEventListener('click', async function () {
      const url = button.dataset.productUrl;
      try {
        await navigator.clipboard.writeText(url);
        button.classList.add('is-copied');
        setTimeout(function () {
          button.classList.remove('is-copied');
        }, 2000);
      } catch (error) {
        console.error('Unable to copy product URL:', error);
      }
    });
  });
});

//////////////////////// for category page filter
// document.addEventListener('DOMContentLoaded', function () {
//     const modalTrigger = document.querySelector(
//         'armada-modal-open[data-modal-id="filter-modal-trigger"]'
//     );
//     const hideSoldout = document.querySelector('#hide_soldout');
//     function hideSoldOutProducts() {
//         const soldOutProducts = document.querySelectorAll(
//             '.template-collection .component-collection-grid .collection-product-item[data-sold-out="true"]'
//         );
//         soldOutProducts.forEach(function (product) {
//             product.classList.add('hide_sold_out');
//         });
//     }
//     // Open filter modal
//     if (modalTrigger && hideSoldout) {
//         modalTrigger.addEventListener('click', function () {
//             hideSoldout.checked = true;
//             hideSoldOutProducts();
//             hideSoldout.dispatchEvent(new Event('change', {
//                 bubbles: true
//             }));
//         });
//     }
//     /*
//      * Watch for Shopify/theme AJAX filter updates.
//      * When the product grid changes, apply the class again.
//      */
//     const collectionGrid = document.querySelector(
//         '.template-collection .component-collection-grid'
//     );
//     if (collectionGrid) {
//         const observer = new MutationObserver(function () {
//             if (hideSoldout && hideSoldout.checked) {
//                 hideSoldOutProducts();
//             }
//         });
//         observer.observe(collectionGrid, {
//             childList: true,
//             subtree: true
//         });
//     }
// });


//////////////////// for slider
(function () {

    function initSliderVisibility() {

        const slideshow = document.querySelector('[data-aid="slideshow"]');

        if (!slideshow) return;

        const slider = slideshow.querySelector('[data-name="slider"]');

        if (!slider) return;

        /*
         * Wait until the Shopify/Armada slider has applied
         * its transform.
         */
        function check() {

            const transform = slider.style.transform;

            if (transform && transform !== 'none') {

                slideshow.classList.add('slider-initialized');

                observer.disconnect();

                return true;
            }

            return false;
        }

        const observer = new MutationObserver(function () {
            check();
        });

        observer.observe(slider, {
            attributes: true,
            attributeFilter: ['style']
        });

        /*
         * Initial check
         */
        check();

        /*
         * Safety fallback.
         */
        setTimeout(function () {

            slideshow.classList.add('slider-initialized');

            observer.disconnect();

        }, 3000);
    }


    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            initSliderVisibility
        );

    } else {

        initSliderVisibility();

    }

})();